import Vue from 'vue'
// import { login, getInfo, logout } from '@/api/login'
// import { logout } from '@/api/login'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { welcome } from '@/utils/util'
const qs = require('querystring')

const user = {
  state: {
    token: '',
    name: '',
    welcome: '',
    avatar: '',
    roles: [],
    info: {}
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, { name, welcome }) => {
      state.name = name
      state.welcome = welcome
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_INFO: (state, info) => {
      state.info = info
    }
  },

  actions: {
    // 登录
    async Login({ commit }, userInfo) {
      // hack for fack login
      const search = qs.decode(location.search)
      if (search.ignoreLogin) {
        console.log(search)
        const token = '4291d7da9005377ec9aec4a71ea837f'
        Vue.ls.set(ACCESS_TOKEN, token, 7 * 24 * 60 * 60 * 1000)
        commit('SET_TOKEN', token)
        return true
      }
      const url = '/oauth/token'
      const token = 'ZGV2OmRldg=='
      Vue.ls.set(ACCESS_TOKEN, token, 7 * 24 * 60 * 60 * 1000)
      // const rz = await login(userInfo)
      const rz = await Vue.axios.post(url, userInfo)
      console.log('Rez', rz)
      if (rz.message) {
        return rz
      }
      Vue.ls.set(ACCESS_TOKEN, rz.access_token, 7 * 24 * 60 * 60 * 1000)
      commit('SET_TOKEN', rz.access_token)
      return rz
    },

    // 获取用户信息
    GetInfo({ commit }) {
      const result = require('@/mock/services/user').userInfo

      if (result.role && result.role.permissions.length > 0) {
        const role = result.role
        role.permissions = result.role.permissions
        role.permissions.map(per => {
          if (per.actionEntitySet != null && per.actionEntitySet.length > 0) {
            const action = per.actionEntitySet.map(action => {
              return action.action
            })
            per.actionList = action
          }
        })
        role.permissionList = role.permissions.map(permission => {
          return permission.permissionId
        })
        commit('SET_ROLES', result.role)
        commit('SET_INFO', result)
      }

      commit('SET_NAME', { name: result.name, welcome: welcome() })
      commit('SET_AVATAR', result.avatar)
      return true
      // return new Promise((resolve, reject) => {
      //   getInfo().then(response => {
      //     const result = response.result

      //     if (result.role && result.role.permissions.length > 0) {
      //       const role = result.role
      //       role.permissions = result.role.permissions
      //       role.permissions.map(per => {
      //         if (per.actionEntitySet != null && per.actionEntitySet.length > 0) {
      //           const action = per.actionEntitySet.map(action => { return action.action })
      //           per.actionList = action
      //         }
      //       })
      //       role.permissionList = role.permissions.map(permission => { return permission.permissionId })
      //       commit('SET_ROLES', result.role)
      //       commit('SET_INFO', result)
      //     } else {
      //       reject(new Error('getInfo: roles must be a non-null array !'))
      //     }

      //     commit('SET_NAME', { name: result.name, welcome: welcome() })
      //     commit('SET_AVATAR', result.avatar)

      //     resolve(response)
      //   }).catch(error => {
      //     reject(error)
      //   })
      // })
    },

    // 登出
    Logout({ commit, state }) {
      commit('SET_TOKEN', '')
      commit('SET_ROLES', [])
      Vue.ls.remove(ACCESS_TOKEN)
      // return new Promise((resolve) => {
      //   logout(state.token).then(() => {
      //     resolve()
      //   }).catch(() => {
      //     resolve()
      //   }).finally(() => {
      //     commit('SET_TOKEN', '')
      //     commit('SET_ROLES', [])
      //     Vue.ls.remove(ACCESS_TOKEN)
      //   })
      // })
    }
  }
}

export default user
